import type { Action } from "redux";
import type { Epic } from "redux-observable";
import type { RootState } from "@/store/app/storeTypes";
import type { EpicDependencies } from "@/store/epics/epicDependencies";
import {
  sparxsCatalogOverviewSubscriptionRequested,
  sparxsCatalogOverviewSubscriptionCancelled,
  REQUEST_KEYS,
} from "@/store/requests/requestsSlice";
import { getCatalogSparxsOverview } from "@/services/statistics.service";
import { normalizeArrayResponse } from "@/lib/http/normalizeArrayResponse";
import { createPeriodScopedPollingSubscription } from "@/store/epics/createPeriodScopedPollingSubscription";
import { map } from "rxjs";

const SUB_KEY_OVERVIEW = "overview";

const sparxsCatalogOverviewEpic: Epic<
  Action,
  Action,
  RootState,
  EpicDependencies
> = (action$, state$, { statisticPollingIntervalMs }) =>
  createPeriodScopedPollingSubscription({
    action$,
    state$,
    requestedType: sparxsCatalogOverviewSubscriptionRequested.type,
    cancelledType: sparxsCatalogOverviewSubscriptionCancelled.type,
    intervalMs: statisticPollingIntervalMs,
    streams: [
      {
        requestKey: REQUEST_KEYS.SPARXS_CATALOG_OVERVIEW,
        subKey: SUB_KEY_OVERVIEW,
        fetch: (profile, period) =>
          getCatalogSparxsOverview(profile, period).pipe(
            map((value) => normalizeArrayResponse(value)),
          ),
      },
    ],
  });

export default sparxsCatalogOverviewEpic;
